<template>
    <b-modal :title="title" ref="mdlSignPrintComponent" size="xl" style="height: 100%" scrollable @shown="onShown" dialog-class="sa-modal-full-height">
        <div style="height: 100%; background-color: transparent">
            <div style="background-color: transparent; height: 80%">
                <slot name="body-component"></slot>
            </div>
            <div>
                <digital-sign-component
                    v-if="showDigitalSignComponent && consensoFirmato.id && pdf"
                    ref="digitalSignComponent"
                    :utente="utenteFirma"
                    :tipoDocumento="title"
                    :idRiferimento="consensoFirmato.id"
                    :filename="digitalSignFileName"
                    :pdf-link="digitalSignPdfLink"
                    :pdf-base64="pdf"
                    :path-resource-digital-sign="pathDigitalSign"
                    codice-applicativo="PAZIENTICONSENSI"
                    @beforeDigitalSignUser="onBeforeDigitalSignUser"
                    @afterDigitalSignUser="onAfterDigitalSignUser"
                    @beforePdfCreate="onBeforePdfCreate"
                    @afterPdfCreate="onAfterPdfCreate"
                    @beforeSign="onBeforeSign"
                    @afterSign="onAfterSign"
                ></digital-sign-component>
                <!-- <b-embed type="iframe" ref="pdfNotSignedEmbeddedComponent" :src="pdf" allowfullscreen></b-embed> -->
                <div v-if="pdf">
                    <div class="sa-tab-scroll"><vue-pdf-embed ref="pdfNotSignedEmbeddedComponent" :source="pdf"></vue-pdf-embed></div>
                </div>
                <!-- <div v-if="pdf"><b-embed type="iframe" ref="pdfNotSignedEmbeddedComponent" :src="pdf" allowfullscreen></b-embed></div> -->
                <div v-else class="sa-badge-container-center">
                    <div class="sa-badge-large">Pdf non ancora disponibile, selezionare un elemento</div>
                </div>
            </div>
        </div>

        <!-- <vue-pdf-embed ref="pdfNotSignedEmbeddedComponent" :source="stampaReport"></vue-pdf-embed> -->
        <template #modal-footer>
            <b-row v-if="tipoFirmaPerFirma === 'GRAFOMETRICA'">
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Dispositivo:</label>
                    <!-- <b-form-select v-model="dispositivo" :options="dispositiviOption" value-field="value" text-field="text"></b-form-select> -->
                </b-col>
            </b-row>
            <b-row v-if="tipoFirmaPerFirma === 'GRAFOMETRICA'">
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-form-select :disabled="isDisableSign" v-model="dispositivo" :options="dispositiviOptions" value-field="value" text-field="text"></b-form-select>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-button :disabled="isDisableSign" size="sm" variant="outline-secondary" @click="handleFirma()">
                        <b-icon icon="pencil-square"></b-icon>
                        {{ buttonLabel }}
                    </b-button>
                    <b-button :disabled="isDisableSign" size="sm" variant="outline-secondary" @click="onPrintNotSigned()">
                        <b-icon icon="printer"></b-icon>
                        Stampa
                    </b-button>
                    <b-button :disabled="pdf === null" size="sm" variant="outline-success" @click="onClickConferma()">Conferma</b-button>
                    <b-button size="sm" variant="danger" @click="onClickClose()">Chiudi</b-button>
                </b-col>
            </b-row>
        </template>
    </b-modal>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import moment from "moment";
import DigitalSignComponent from "./DigitalSignComponent.vue";
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
export default {
    components: { DigitalSignComponent, VuePdfEmbed },
    props: {
        tipoFirma: { type: String, default: null },
        utente: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            title: "",
            pdf: null,
            dispositivo: "",
            dispositiviOptions: [{ value: "", text: "-Seleziona Dispositivo-" }],
            pathResourceDispositivi: "/digitalsigndevice",
            consensoFirmato: {},
            isDisableSign: true,
            pathDigitalSign: "/sign/internal",
        };
    },
    computed: {
        showDigitalSignComponent() {
            return this.tipoFirmaPerFirma === "DIGITALE";
        },
        digitalSignFileName() {
            return this.consensoFirmato.nomeConsenso ? this.consensoFirmato.nomeConsenso + moment(new Date()).format("YYYY_MM_DD_HHmmss") + ".pdf" : "consenso.pdf";
        },
        digitalSignPdfLink() {
            return "";
        },
        tipoFirmaPerFirma() {
            if (this.tipoFirma === "firmaDigitale" || this.tipoFirma === "DIGITALE") {
                return "DIGITALE";
            }
            if (this.tipoFirma === "firmaGrafometrica" || this.tipoFirma === "GRAFOMETRICA") {
                return "GRAFOMETRICA";
            }
            return "GRAFOMETRICA";
        },
        buttonLabel() {
            return this.tipoFirmaPerFirma === "DIGITALE" ? "Firma Digitale" : "Firma Grafometrica";
        },
        utenteFirma() {
            const user = this.utente && Object.keys(this.utente).length > 0 ? this.utente : Vue.prototype.user || {};

            return {
                ...user,
                id: user.id || user.idUtente,
            };
        },
    },
    watch: {
        tipoFirma() {
            this.loadDevice();
        },
    },
    mounted() {
        this.loadDevice();
    },
    methods: {
        show() {
            this.$refs.mdlSignPrintComponent.show();
        },
        hide() {
            this.consensoFirmato = {};
            this.pdf = null;
            this.$refs.mdlSignPrintComponent.hide();
        },
        init() {
            this.pdf = null;
            this.consensoFirmato = {};
            this.$refs.mdlSignPrintComponent.show();
        },
        loadDevice() {
            if (this.tipoFirmaPerFirma !== "GRAFOMETRICA") {
                return;
            }
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceDispositivi;
            let filtro = { tipoFirma: me.tipoFirmaPerFirma, gestore: "KEFIRMA" };
            me.dispositiviOptions = [];
            axios
                .get(link, { params: filtro })
                .then((response) => {
                    response.data.data.list.forEach((element) => {
                        me.dispositiviOptions.push({ value: element.codiceDispositivo, text: element.descrizioneDispositivo + " (" + element.codiceDispositivo + ")" });
                    });
                    me.dispositiviOptions.unshift({ value: "", text: "-Seleziona Dispositivo-" });
                })
                .catch(() => {
                    // console.log(e);
                    //   this.errors.push(e);
                });
        },
        onShown() {
            if (this.pdf === null) {
                this.isDisableSign = true;
                this.pdf = null;
                this.title = "---";
                this.$emit("onshown");
            }
        },
        setData(title, pdf) {
            this.title = title;
            this.pdf = pdf;
            // console.log(pdf);
        },
        setDataForSign(consenso) {
            let me = this;
            // console.log(consenso);

            // me.consensoFirmato = { id: consenso.idRisorsa, nomeConsenso: consenso.tipoDocumento };
            me.consensoFirmato = { id: consenso.idRisorsa, nomeConsenso: consenso.tipoDocumento };
            this.isDisableSign = false;
            me.title = consenso.tipoDocumento;
            this.pdf = consenso.base64.includes("data:application/pdf;base64,") ? consenso.base64 : "data:application/pdf;base64," + consenso.base64;
            me.$refs.mdlSignPrintComponent.show();
        },
        onClickClose() {
            let me = this;
            me.mdlStampaFirmaGrafometricaClose();
        },
        mdlStampaFirmaGrafometricaClose() {
            let me = this;
            me.$refs.mdlSignPrintComponent.hide();
        },
        handleFirma() {
            if (this.tipoFirmaPerFirma === "DIGITALE") {
                this.onFirmaDigitale();
            } else {
                this.onFirmaGrafometrica();
            }
        },
        onFirmaGrafometrica() {
            let me = this;
            let file = this.pdf.replace("data:application/pdf;base64,", "");

            let signBean = {
                tipo: me.tipoFirmaPerFirma,
                codiceDispositivo: me.dispositivo,
                gestore: "KEFIRMA",
                codiceApplicativo: "PAZIENTICONSENSI",
                files: [{ idRiferimento: me.consensoFirmato.id, filename: me.consensoFirmato.nomeConsenso + moment(new Date()).format("YYYY_MM_DD_HHmmss") + ".pdf", fileBase64: file }],
            };
            me.digilatSignRequest(signBean);
        },
        onFirmaDigitale() {
            if (this.$refs.digitalSignComponent && this.$refs.digitalSignComponent.onFirma) {
                this.$refs.digitalSignComponent.onFirma();
            }
        },
        onBeforeDigitalSignUser() {
            this.isDisableSign = true;
        },
        onAfterDigitalSignUser() {
            this.isDisableSign = false;
        },
        onBeforePdfCreate() {
            this.isDisableSign = true;
        },
        onAfterPdfCreate() {
            this.isDisableSign = false;
        },
        onBeforeSign() {
            this.isDisableSign = true;
        },
        onAfterSign() {
            this.isDisableSign = false;
            this.$refs.mdlSignPrintComponent.hide();
            this.$emit("afterSign");
        },
        onPrintNotSigned() {},
        onClickConferma() {
            this.isDisableSign = false;
            // console.log(this.pdf);

            this.$emit("confermaSelezione", this.pdf);
        },
        initConsenso(consensoFirmato) {
            let me = this;
            me.consensoFirmato = consensoFirmato;
            if (me.pdf && me.consensoFirmato && me.consensoFirmato.id) {
                me.isDisableSign = false;
            }
        },
        digilatSignRequest(signBean) {
            let me = this;
            if (signBean.tipo === "GRAFOMETRICA") {
                me.pathDigitalSign = "/sign/internal";
            }
            let link = process.env.VUE_APP_PATH_API + me.pathDigitalSign;
            // me.showModalLoading = true;
            // me.$refs.mdlInvioAlDispositivoInCorso.show();
            console.log(signBean);

            axios
                .post(link, signBean)
                .then((response) => {
                    // me.$refs.mdlInvioAlDispositivoInCorso.hide();
                    let message = response.data.messaggio;

                    this.$bvModal
                        .msgBoxOk(message, {
                            title: "Info",
                            size: "sm",
                            okVariant: "outline-success",
                            headerClass: "sa-msg-header-success",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                        })
                        .then(() => {
                            me.$refs.mdlSignPrintComponent.hide();
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                })
                .catch((error) => {
                    me.$emit("closeModal");
                    let message = "";
                    error.response ? error.response.data.messaggio : "Errore non gestito";
                    if (error.response) {
                        message = error.response.data.messaggio ? error.response.data.messaggio : "Codice Errore: " + error.response.status + ", non gestito";
                    }
                    if (error.response) {
                        this.$bvModal
                            .msgBoxOk(message, {
                                title: "ATTENZIONE",
                                size: "sm",
                                okVariant: "outline-danger",
                                headerClass: "sa-msg-header-danger",
                                footerClass: "p-2 border-top-0",
                                centered: true,
                            })
                            .then(() => {})
                            .catch((err) => {
                                console.log(err);
                            });
                    }
                });
        },
    },
};
</script>

<style></style>
